<template>
  <v-container class="d-flex justify-center">
    <v-card flat>
      <h1>{{$t('notfound.title')}}</h1>
      <div class="mt-5 mb-5 d-flex justify-center">
        <v-icon class="link-broken">$sl-unlink</v-icon>
      </div>

      <p>
        <b>{{$t('notfound.text1')}}</b>
      </p>
      <p>{{$t('notfound.text2')}}</p>

      <ActionButton
        class="mt-6"
        :block="false"
        :width="'140px'"
        actionIcon="$sl-arrow-left"
        @click="$router.push('/')"
      >{{ $t('notfound.button') }}</ActionButton>
    </v-card>
  </v-container>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton'
// @group Common
// NotFound component
export default {
  name: 'NotFound',
  components: {
    ActionButton
  }
}
</script>

<style scoped>
.link-broken {
  width: 192px;
  height: 192px;
}
</style>